interface selectAddonData {
    e: any,
    addOnItem: any,
    itemAddOnAllData: any
    selectAddOn: any,
    setSelectedAddOn: any

}

const SelectAddOnData = async ({ e, addOnItem, itemAddOnAllData, selectAddOn, setSelectedAddOn }: selectAddonData) => {

    if (e.target.checked) {
        const allAddOnData = [...selectAddOn, addOnItem];
        await setSelectedAddOn(allAddOnData);
    } else {
        const allSelectedAddonss = [...selectAddOn];
        const index = allSelectedAddonss.indexOf(addOnItem);
        if (index !== -1) {
            allSelectedAddonss.splice(index, 1);
            const newData = allSelectedAddonss;
            setSelectedAddOn(newData);
        }
    }
}

export default SelectAddOnData;